let loadPromise = null

export function loadGoogleMaps(apiKey) {
  if (!apiKey) return Promise.resolve(false)
  if (typeof window === 'undefined') return Promise.resolve(false)
  if (window.google?.maps?.places) return Promise.resolve(true)
  if (loadPromise) return loadPromise

  loadPromise = new Promise((resolve) => {
    const script = document.createElement('script')
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&libraries=places&loading=async&v=weekly&region=US&language=en`
    script.async = true
    script.defer = true
    script.onload = () => {
      // The script can "load" even when blocked by a client (ad-blocker, Brave
      // shields) — onload fires but window.google.maps.places never attaches.
      // With loading=async, places can also appear slightly after onload.
      // Poll briefly for it; only report success when it's actually there.
      if (window.google?.maps?.places) {
        resolve(true)
        return
      }
      let waited = 0
      const interval = setInterval(() => {
        if (window.google?.maps?.places) {
          clearInterval(interval)
          resolve(true)
        } else if ((waited += 100) >= 2000) {
          clearInterval(interval)
          loadPromise = null
          resolve(false)
        }
      }, 100)
    }
    script.onerror = () => {
      loadPromise = null
      resolve(false)
    }
    document.head.appendChild(script)
  })
  return loadPromise
}
